import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ContactInfoSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  isCollapsed, 
  onToggleCollapse 
}) => {
  return (
    <div className="bg-card border border-border rounded-lg shadow-spiritual-sm mb-6">
      <div 
        className="flex items-center justify-between p-4 cursor-pointer hover:bg-muted/50 transition-colors"
        onClick={onToggleCollapse}
      >
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="MapPin" size={20} className="text-accent" />
          </div>
          <div>
            <h3 className="font-heading font-semibold text-foreground">
              Contact Information
            </h3>
            <p className="text-sm text-muted-foreground">
              Email address and residential details
            </p>
          </div>
        </div>
        <Icon 
          name={isCollapsed ? "ChevronDown" : "ChevronUp"} 
          size={20} 
          className="text-muted-foreground" 
        />
      </div>

      {!isCollapsed && (
        <div className="p-6 pt-6 border-t border-border">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="md:col-span-2">
              <Input
                label="Email Address"
                type="email"
                placeholder="Enter email address"
                value={formData.emailId}
                onChange={(e) => handleInputChange('emailId', e.target.value)}
                error={errors.emailId}
              />
            </div>

            <Input
              label="Door Number"
              type="text"
              placeholder="Enter door number"
              value={formData.doorNo}
              onChange={(e) => handleInputChange('doorNo', e.target.value)}
              error={errors.doorNo}
            />

            <Input
              label="ZIP Code"
              type="text"
              placeholder="Enter ZIP code"
              value={formData.pinCode}
              onChange={(e) => handleInputChange('pinCode', e.target.value)}
              error={errors.pinCode}
            />

            <div className="md:col-span-2">
              <Input
                label="Address Line 1"
                type="text"
                placeholder="Enter address line 1"
                value={formData.addressLine1}
                onChange={(e) => handleInputChange('addressLine1', e.target.value)}
                error={errors.addressLine1}
              />
            </div>

            <div className="md:col-span-2">
              <Input
                label="Address Line 2"
                type="text"
                placeholder="Enter address line 2 (optional)"
                value={formData.addressLine2}
                onChange={(e) => handleInputChange('addressLine2', e.target.value)}
                error={errors.addressLine2}
              />
            </div>

            <div className="md:col-span-2">
              <Input
                label="City"
                type="text"
                placeholder="Enter city"
                value={formData.city}
                onChange={(e) => handleInputChange('city', e.target.value)}
                error={errors.city}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactInfoSection;